/* Scentoria — Shopify AJAX Cart + UI */

function shopifyAddToCart(variantId, btn) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
  })
  .then(r => r.json())
  .then(item => {
    if (item.status) { scentToast('Error: ' + (item.description || 'Could not add')); return; }
    scentToast('Added to bag ✓');
    if (btn) { btn.textContent = 'Added ✓'; btn.classList.add('added'); setTimeout(() => { btn.textContent = 'Add to bag'; btn.classList.remove('added'); }, 1400); }
    return fetch('/cart.js');
  })
  .then(r => r && r.json())
  .then(cart => { if (cart) { updateCartCount(cart.item_count); renderCartFromData(cart); } })
  .catch(() => scentToast('Error adding to bag'));
}

function fetchCart() {
  fetch('/cart.js').then(r => r.json()).then(cart => { updateCartCount(cart.item_count); renderCartFromData(cart); });
}

function updateCartCount(count) {
  const el = document.getElementById('cart-count');
  if (el) { el.textContent = count; el.style.display = count > 0 ? 'flex' : 'none'; }
}

function renderCartFromData(cart) {
  const wrap = document.getElementById('cart-items');
  const totalEl = document.getElementById('cart-total');
  if (!wrap) return;
  if (!cart.items || cart.items.length === 0) {
    wrap.innerHTML = '<div class="cart-empty">Your bag is empty.<br/>Find something beautiful. 🌸</div>';
    if (totalEl) totalEl.textContent = '$0.00';
    return;
  }
  wrap.innerHTML = cart.items.map(item => `
    <div class="cart-item">
      <div class="ci-img" style="background:#f5f0ea">${item.image ? `<img src="${item.image}" alt="${item.product_title}" style="width:100%;height:100%;object-fit:cover;border-radius:6px;">` : '🌸'}</div>
      <div>
        <div class="ci-house">${item.vendor || ''}</div>
        <div class="ci-name">${item.product_title}</div>
        <div class="ci-qty">
          <button onclick="changeCartQty(${item.variant_id},${item.quantity - 1})">-</button>
          <span>${item.quantity}</span>
          <button onclick="changeCartQty(${item.variant_id},${item.quantity + 1})">+</button>
        </div>
        <button class="ci-remove" onclick="changeCartQty(${item.variant_id},0)">Remove</button>
      </div>
      <div class="ci-price">${formatMoney(item.line_price)}</div>
    </div>
  `).join('');
  if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
}

function changeCartQty(variantId, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty })
  }).then(r => r.json()).then(cart => { updateCartCount(cart.item_count); renderCartFromData(cart); });
}

function formatMoney(cents) { return '$' + (cents / 100).toFixed(2); }

function openCart() {
  document.getElementById('cart-drawer')?.classList.add('open');
  document.getElementById('cart-overlay')?.classList.add('open');
  fetchCart();
}
function closeCart() {
  document.getElementById('cart-drawer')?.classList.remove('open');
  document.getElementById('cart-overlay')?.classList.remove('open');
}

let toastTimer;
function scentToast(msg) {
  let t = document.querySelector('.toast');
  if (!t) { t = document.createElement('div'); t.className = 'toast'; document.body.appendChild(t); }
  t.textContent = msg;
  requestAnimationFrame(() => t.classList.add('show'));
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => t.classList.remove('show'), 2200);
}

function handleNewsletter(e) {
  e.preventDefault();
  const form = e.target;
  const input = form.querySelector('input[type="email"]');
  if (input && input.value) {
    form.innerHTML = '<p style="padding:0.7rem 1.2rem;margin:0;font-size:0.9rem;color:#fff;">✓ Subscribed — your 10% code is on the way.</p>';
  }
}

document.addEventListener('DOMContentLoaded', () => { fetchCart(); });
